var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Form, Select, Skeleton } from '@robinpowered/ui-kit';
import { useTranslation } from 'react-i18next';
import { useCalendarIntegrationsContext } from '../context/CalendarIntegrationContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@awesome.me/kit-cf858715fd/icons/classic/light';
import styled from '@emotion/styled';
var StyledSkeletonInput = styled(Skeleton.Input)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100% !important;\n  height: 20px !important;\n"], ["\n  width: 100% !important;\n  height: 20px !important;\n"])));
export var CalendarSelector = function () {
    var _a;
    var t = useTranslation('meetingRooms').t;
    var _b = useCalendarIntegrationsContext(), calendars = _b.calendars, selectedCalendar = _b.selectedCalendar, setSelectedCalendar = _b.setSelectedCalendar, isLoadingCalendarIntegration = _b.isLoadingCalendarIntegration, personalBookingEnabled = _b.personalBookingEnabled;
    if (isLoadingCalendarIntegration) {
        return (_jsx(Form.Item, { children: _jsx(StyledSkeletonInput, { active: true }) }));
    }
    // Only render when personal booking is on and we have (or are loading) calendars
    if (!personalBookingEnabled || calendars.length <= 1) {
        return null;
    }
    return (_jsx(Form.Item, { children: _jsx(Select, { loading: isLoadingCalendarIntegration, disabled: isLoadingCalendarIntegration, style: { width: '100%' }, value: (_a = selectedCalendar === null || selectedCalendar === void 0 ? void 0 : selectedCalendar.mailbox_address) !== null && _a !== void 0 ? _a : undefined, onChange: function (value) {
                /* @TODO this should be optimized (use a map) */
                var calendar = calendars.find(function (c) { return c.mailbox_address === value; });
                if (calendar) {
                    setSelectedCalendar(calendar);
                }
            }, prefix: _jsx(FontAwesomeIcon, { icon: faCalendar }), options: calendars.map(function (calendar) {
                return {
                    value: calendar.mailbox_address,
                    label: calendar.is_primary
                        ? t('calendar_select.calendar_label', {
                            name: calendar.name,
                            address: calendar.mailbox_address,
                        })
                        : calendar.name,
                };
            }), placeholder: t('calendar_select.placeholder') }) }));
};
var templateObject_1;
